import { useContext } from "react";
import {
	Drawer,
	IconButton,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	useMediaQuery,
} from "@mui/material";
import { sideNavigationItems } from "../../../config/static";
import { SideNavigationWrapper } from "./styled";
import { Context } from "../../../context";
import { SideNavFavicon, SideNavProfileIcon } from "../../../assets";
import { ArrowForwardIos, Close } from "@mui/icons-material";
import { Menu } from "../../../components/menu";
import { useNavigate } from "react-router-dom";

export const SideNavigation = () => {
	const noSubNavItems = ["Dashboard", "Migration"];
	const navigate = useNavigate();
	const matches = useMediaQuery("(min-width:482px)");
	const {
		activeNavItem,
		setActiveNavItem,
		setIsSideNavigationClosing,
		mobileSideNavigationOpen,
		setMobileSideNavigationOpen,
	} = useContext(Context);

	const handleDrawerClose = () => {
		setIsSideNavigationClosing(true);
		setMobileSideNavigationOpen(false);
	};

	const handleDrawerTransitionEnd = () => {
		setIsSideNavigationClosing(false);
	};

	const handleNavItemClick = (item: string) => {
		if (noSubNavItems.includes(item)) {
			return navigate(`/${item.toLowerCase()}`);
		}
		// reset active nav item to default and toggle close dropdown
		if (item === activeNavItem) {
			return setActiveNavItem(undefined);
		}
		return setActiveNavItem(item);
	};

	const drawer = sideNavigationItems.map((sideNavItem, index) => {
		return (
			<ListItem
				key={index}
				className={`${sideNavItem.name}-item`}
				component={"div"}
				sx={{
					flexDirection: "column",
					alignItems: "stretch",
					marginTop: index === 0 ? "calc(var(--basic-margin)/2)" : "0",
				}}
				onClick={() => handleNavItemClick(sideNavItem.name)}
			>
				<ListItemButton>
					<ListItemIcon>{sideNavItem.icon}</ListItemIcon>
					<ListItemText primary={sideNavItem.name} />
					<ListItemIcon
						sx={{
							display: index === 0 || index === 5 ? "none" : "inline-flex",
							justifyContent: "flex-end",
						}}
						className="arrow-box"
					>
						<ArrowForwardIos sx={{ color: "#FFFFFF" }} />
					</ListItemIcon>
				</ListItemButton>
				{!noSubNavItems.includes(sideNavItem.name) && (
					<Menu
						location="side-navigation"
						open={activeNavItem === sideNavItem.name}
						menuitems={sideNavItem.items}
					/>
				)}
			</ListItem>
		);
	});
	return (
		<SideNavigationWrapper
			sx={{
				width: { mobile: "var(--side-nav-width)" },
				flexShrink: { mobile: 0 },
			}}
		>
			<Drawer
				variant="temporary"
				open={mobileSideNavigationOpen}
				onTransitionEnd={handleDrawerTransitionEnd}
				onClose={handleDrawerClose}
				ModalProps={{
					keepMounted: true,
				}}
				sx={{
					display: { mobile: "block", tablet: "none" },
					"& .MuiDrawer-paper": {
						boxSizing: "border-box",
						width: "var(--side-nav-width)",
					},
				}}
			>
				<ListItem className="app-icon">
					<ListItemIcon>
						<SideNavProfileIcon />
					</ListItemIcon>
					<ListItemText primary={"Super Admin"} sx={{ color: "#FAF6F6" }} />
					<IconButton
						sx={{
							color: "#FAF6F6",
							border: "1px solid #FAF6F6",
							borderRadius: "50%",
							display: matches ? "none" : "inline-flex",
						}}
						onClick={handleDrawerClose}
					>
						<Close />
					</IconButton>
				</ListItem>
				{drawer}
			</Drawer>
			<Drawer
				variant="permanent"
				sx={{
					display: { mobile: "none", tablet: "block" },
					"& .MuiDrawer-paper": {
						boxSizing: "border-box",
						width: "var(--side-nav-width)",
					},
				}}
				open
			>
				<ListItem>
					<ListItemIcon
						sx={{
							marginRight: "auto",
							marginLeft: "auto",
						}}
					>
						<SideNavFavicon />
					</ListItemIcon>
				</ListItem>
				<ListItem className="app-icon">
					<ListItemIcon>
						<SideNavProfileIcon />
					</ListItemIcon>
					<ListItemText primary={"Super Admin"} sx={{ color: "#FAF6F6" }} />
				</ListItem>
				{drawer}
			</Drawer>
		</SideNavigationWrapper>
	);
};
